import React from "react";
import { Routes, Route } from "react-router-dom";

// import Footer from "../Components/Common/Footer_Trial";
import TopPageScroll from "../Components/Common/TopPageScroll";
// import Career from "../Pages/Career";
import Home from "../Pages/Home";
import Team from "../Pages/Team.js";
import Projects from "../Pages/Projects/Projects.js";
import Publications from "../Pages/Publications";
import PublicationView from "../Pages/PublicationsView.js";
import Research from "../Pages/Research/Research.js";
// import SEED from "../Pages/SEED";
import TwoDimensional from "../Pages/Research/TwoDimensional.js";
import ThreeDimensional from "../Pages/Research/ThreeDimensional.js";
import Multimodal from "../Pages/Projects/Multimodal.js";

// import SeedTrial from "../Pages/SeedTrial";
import ContactUs from "../Pages/ContactUs";
// import Projects_page from "../Page_Layouts/Projects_page";
import SponsoredResearch from "../Pages/Projects/SponsoredResearch.js";
import Consultancy from "../Pages/Projects/Consultancy.js";
import AicteRps from "../Pages/Projects/SRP/AicteRps.js";
import IHDS from "../Pages/Projects/SRP/IHDS.js";
import KALPIT from "../Pages/Projects/SRP/Kalpit.js";
import Vaidya from "../Pages/Projects/SRP/Vaidya.js";
import DstDp from "../Pages/Projects/SRP/DstDp.js";
import TwoDDACS from "../Pages/Research/2D/TwoDDACS.js";
import IRE from "../Pages/Research/2D/IRE.js";
import LR2D from "../Pages/Research/2D/LR2D.js";
import FCC2D from "../Pages/Research/2D/FCC2D.js";
import QAI from "../Pages/Research/2D/QAI.js";
import DLT from "../Pages/Research/2D/DLT.js";
import ThreeDA from "../Pages/Research/3D/ThreeDA.js";
import ThreeDRR from "../Pages/Research/3D/ThreeDRR.js";
import LR3D from "../Pages/Research/3D/LR3D.js";
import R3D from "../Pages/Research/3D/R3D.js";
import ThreeDFCC from "../Pages/Research/3D/ThreeDFCC.js";
import ThreeDODT from "../Pages/Research/3D/ThreeDODT.js";
import Datasets from "../Pages/Datasets";
import DatasetPage from "../Pages/DatasetPage.js";
// import Dataset_RSUIGM from "../Pages/Dataset_RSUIGM";
import AboutUs from "../Pages/AboutUs";

import KalpitAssets from "../Pages/KALPIT/KalpitAssets.js";
import KalpitHome from "../Pages/KALPIT/KalpitHome.js";

import ErrorPage from "../Pages/ErrorPage.js";

// import { Link } from "react-router-dom";
// import Breadcrumbs from "../Components/Common/Breadcrumbs";


function Router() {
  // const location = useLocation();
  // const navigate = useNavigate();
  // const currentPath = location.pathname;

  return (
    <>
      <TopPageScroll />
      {/* <Breadcrumbs />  */}
      <Routes>
        {/* <Route exact path="/AboutUs" element={<About_Trial />} />
        <Route exact path="/career" element={<Career />} /> */}
        <Route path="/error" element={<ErrorPage/>}/>
        <Route exact path="/contact" element={<ContactUs />} />
        <Route exact path="/" element={<Home />} />
        <Route exact path="/aboutus" element={<AboutUs />} />
        <Route exact path="/team" element={<Team />} />
        <Route exact path="/projects" element={<Projects />} />
        <Route exact path="/publications" element={<Publications />} />
        <Route exact path="/research" element={<Research />} />
        {/* <Route path="/seed" element={<SeedTrial />} /> */}
        <Route path="/publications_view" element={<PublicationView />} />
        <Route path="/research/2d" element={<TwoDimensional />} />
        <Route path="/research/3d" element={<ThreeDimensional />} />
        <Route path="/research/multimodal" element={<Multimodal />} />
        <Route path="/projects/sponsored" element={<SponsoredResearch />} />
        <Route path="/projects/consultancy" element={<Consultancy />} />
        <Route path="/projects/sponsored/aicte_rps" element={<AicteRps />} />
        <Route path="/projects/sponsored/ihds" element={<IHDS />} />
        <Route path="/projects/sponsored/kalpit" element={<KALPIT />} />
        <Route path="/projects/sponsored/vaidya" element={<Vaidya />} />
        <Route path="/projects/sponsored/dst-dp" element={<DstDp />} />
        <Route path="/projects/sponsored/kalpit/assets" element={<KalpitHome/>} />
        <Route path="/projects/sponsored/kalpit/assets/characters" element={<KalpitAssets/>} />
        <Route path="/projects/sponsored/kalpit/assets/handhelds" element={<KalpitAssets/>} />
        <Route path="/projects/sponsored/kalpit/assets/pillars" element={<KalpitAssets/>} />
        <Route path="/projects/sponsored/kalpit/assets/scene-elements" element={<KalpitAssets/>} />
        <Route path="/projects/sponsored/kalpit/assets/toys" element={<KalpitAssets/>} />
        <Route path="/projects/sponsored/kalpit/assets/utensils" element={<KalpitAssets/>} />
        <Route path="/projects/sponsored/kalpit/assets/wearables" element={<KalpitAssets/>} />
        <Route path="/research/2d/2DDACS" element={<TwoDDACS/>} />
        <Route path="/research/2d/IRE" element={<IRE/>} />
        <Route path="/research/2d/LR2D" element={<LR2D/>} />
        <Route path="/research/2d/FCC2D" element={<FCC2D/>} />
        <Route path="/research/2d/QAI" element={<QAI/>} />
        <Route path="/research/2d/DLT" element={<DLT/>} />
        <Route path="/research/3d/3DA" element={<ThreeDA/>} />
        <Route path="/research/3d/3DRR" element={<ThreeDRR/>} />
        <Route path="/research/3d/LR3D" element={<LR3D/>} />
        <Route path="/research/3d/R3D" element={<R3D/>} />
        <Route path="/research/3d/3DFCC" element={<ThreeDFCC/>} />
        <Route path="/research/3d/3DODT" element={<ThreeDODT/>} />
        <Route path="/dataset" element={<Datasets/>} />
        <Route path="/dataset_page" element={<DatasetPage/>} />
        {/* <Route path="*" element={<navigate to="/" />}/> */}
        {/* <Route path="*" element={<navigate to="/" />}/> */}
      </Routes>
    </>
  );
}

export default Router;
